<div [formGroup]="criteriaFormGroup"
  class="wrapper"
  [class.is-modal-view]="isModalView">
  <div *ngIf="!hideObjectSelector"
    class="object-container">
    <!-- Object -->
    <yc-typeahead-select 
      name="object"
      [items]="objectOptions"
      [dropdownPosition]="'top'"
      [placeholder]="'common:lblDashedPleaseSelect' | ycI18n: '-- Please Select --'"
      (onChange)="handleObjectChange($event)">
    </yc-typeahead-select>
  </div>
  <div class="column-container"
    [class.hide-object]="hideObjectSelector">
    <!-- Column -->
    <yc-typeahead-select *ngIf="columnOptions"
      name="column"
      [label]="'common:textColumn' | ycI18n: 'Column'"
      [srOnlyLabel]="true"
      [showClear]="false"
      [dropdownPosition]="'top'"
      [items]="columnOptions"
      [placeholder]="'common:lblDashedPleaseSelect' | ycI18n: '-- Please Select --'"
      (onChange)="handleColumnChange($event)">
    </yc-typeahead-select>
  </div>
  <div class="comparison-container"
    [class.hide-object]="hideObjectSelector">
    <!-- Comparison / Value -->
    <gc-automation-criteria-value
      [valuesHidden]="!currentComparison && currentComparison !== 0"
      [criteriaFormGroup]="criteriaFormGroup"
      [currentComparison]="currentComparison"
      [columnComparisonOptions]="columnComparisonOptions"
      (removeRule)="onRemove.emit()">
    </gc-automation-criteria-value>
  </div>
</div>